import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { o as e, b as t, c as r } from "../../chunks/vec2.js";
import { a, f as i, d as n } from "../../chunks/vec2f64.js";
import { e as s, i as o, g as u } from "../../chunks/vec3.js";
import { f as c, c as h, d as p } from "../../chunks/vec3f64.js";
import { l as v, c as y } from "../../chunks/vec4.js";
import { c as l, f as d, d as f } from "../../chunks/vec4f64.js";
import T from "../../geometry/Point.js";

var m = /*#__PURE__*/function () {
  function m(e) {
    _classCallCheck(this, m);

    this.spatialReference = e;
  }

  _createClass(m, [{
    key: "createVector",
    value: function createVector() {
      return this.tag(a());
    }
  }, {
    key: "pointToVector",
    value: function pointToVector(e) {
      return this.tag(i(e.x, e.y));
    }
  }, {
    key: "arrayToVector",
    value: function arrayToVector(e) {
      return this.tag(i(e[0], e[1]));
    }
  }, {
    key: "vectorToArray",
    value: function vectorToArray(e) {
      return [e[0], e[1]];
    }
  }, {
    key: "pointToArray",
    value: function pointToArray(e) {
      return [e.x, e.y];
    }
  }, {
    key: "vectorToPoint",
    value: function vectorToPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new T();
      return t.x = e[0], t.y = e[1], t.z = void 0, t.m = void 0, t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "arrayToPoint",
    value: function arrayToPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new T();
      return t.x = e[0], t.y = e[1], t.z = void 0, t.m = void 0, t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "vectorToDehydratedPoint",
    value: function vectorToDehydratedPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        x: void 0,
        y: void 0,
        z: void 0,
        m: void 0,
        hasZ: void 0,
        hasM: void 0,
        spatialReference: void 0,
        type: "point"
      };
      return t.x = e[0], t.y = e[1], t.z = void 0, t.m = void 0, t.hasZ = !1, t.hasM = !1, t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "lerp",
    value: function lerp(t, r, a, i) {
      return e(i, t, r, a);
    }
  }, {
    key: "addDelta",
    value: function addDelta(e, t, r) {
      e[0] += t, e[1] += r;
    }
  }, {
    key: "distance",
    value: function distance(e, r) {
      return t(e, r);
    }
  }, {
    key: "getZ",
    value: function getZ(e, t) {
      return t;
    }
  }, {
    key: "hasZ",
    value: function hasZ() {
      return !1;
    }
  }, {
    key: "getM",
    value: function getM(e, t) {
      return t;
    }
  }, {
    key: "hasM",
    value: function hasM() {
      return !1;
    }
  }, {
    key: "clone",
    value: function clone(e) {
      return this.tag(n(e));
    }
  }, {
    key: "copy",
    value: function copy(e, t) {
      return r(t, e);
    }
  }, {
    key: "fromXYZ",
    value: function fromXYZ(e) {
      return this.tag(i(e[0], e[1]));
    }
  }, {
    key: "toXYZ",
    value: function toXYZ(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return c(e[0], e[1], t);
    }
  }, {
    key: "tag",
    value: function tag(e) {
      return e;
    }
  }]);

  return m;
}();

var g = /*#__PURE__*/function () {
  function g(e, t) {
    _classCallCheck(this, g);

    this.valueType = e, this.spatialReference = t;
  }

  _createClass(g, [{
    key: "createVector",
    value: function createVector() {
      return this.tag(h());
    }
  }, {
    key: "pointToVector",
    value: function pointToVector(e) {
      return this.tag(c(e.x, e.y, 0 === this.valueType ? e.z : e.m));
    }
  }, {
    key: "arrayToVector",
    value: function arrayToVector(e) {
      return this.tag(c(e[0], e[1], e[2] || 0));
    }
  }, {
    key: "vectorToArray",
    value: function vectorToArray(e) {
      return [e[0], e[1], e[2]];
    }
  }, {
    key: "pointToArray",
    value: function pointToArray(e) {
      return 0 === this.valueType ? [e.x, e.y, e.z] : [e.x, e.y, e.m];
    }
  }, {
    key: "vectorToPoint",
    value: function vectorToPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new T();
      return t.x = e[0], t.y = e[1], t.z = 0 === this.valueType ? e[2] : void 0, t.m = 1 === this.valueType ? e[2] : void 0, t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "arrayToPoint",
    value: function arrayToPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new T();
      return t.x = e[0], t.y = e[1], t.z = 0 === this.valueType ? e[2] : void 0, t.m = 1 === this.valueType ? e[2] : void 0, t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "vectorToDehydratedPoint",
    value: function vectorToDehydratedPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        x: void 0,
        y: void 0,
        z: void 0,
        m: void 0,
        hasZ: void 0,
        hasM: void 0,
        spatialReference: void 0,
        type: "point"
      };
      var r = 0 === this.valueType,
          a = 1 === this.valueType;
      return t.x = e[0], t.y = e[1], t.z = r ? e[2] : void 0, t.m = a ? e[2] : void 0, t.hasZ = r, t.hasM = a, t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "lerp",
    value: function lerp(e, t, r, a) {
      return s(a, e, t, r);
    }
  }, {
    key: "addDelta",
    value: function addDelta(e, t, r, a) {
      e[0] += t, e[1] += r, 0 === this.valueType && (e[2] += a);
    }
  }, {
    key: "distance",
    value: function distance(e, r) {
      return 0 === this.valueType ? o(e, r) : t(e, r);
    }
  }, {
    key: "getZ",
    value: function getZ(e, t) {
      return 0 === this.valueType ? e[2] : t;
    }
  }, {
    key: "hasZ",
    value: function hasZ() {
      return 0 === this.valueType;
    }
  }, {
    key: "getM",
    value: function getM(e, t) {
      return 1 === this.valueType ? e[2] : t;
    }
  }, {
    key: "hasM",
    value: function hasM() {
      return 1 === this.valueType;
    }
  }, {
    key: "clone",
    value: function clone(e) {
      return this.tag(p(e));
    }
  }, {
    key: "copy",
    value: function copy(e, t) {
      return u(t, e);
    }
  }, {
    key: "fromXYZ",
    value: function fromXYZ(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return this.tag(c(e[0], e[1], 0 === this.valueType ? e.length > 2 ? e[2] : t : r));
    }
  }, {
    key: "toXYZ",
    value: function toXYZ(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.tag(c(e[0], e[1], 0 === this.valueType ? e[2] : t));
    }
  }, {
    key: "tag",
    value: function tag(e) {
      return e;
    }
  }]);

  return g;
}();

var R = /*#__PURE__*/function () {
  function R(e) {
    _classCallCheck(this, R);

    this.spatialReference = e;
  }

  _createClass(R, [{
    key: "createVector",
    value: function createVector() {
      return this.tag(l());
    }
  }, {
    key: "pointToVector",
    value: function pointToVector(e) {
      return this.tag(d(e.x, e.y, e.z, e.m));
    }
  }, {
    key: "arrayToVector",
    value: function arrayToVector(e) {
      return this.tag(d(e[0], e[1], e[2] || 0, e[3] || 0));
    }
  }, {
    key: "vectorToArray",
    value: function vectorToArray(e) {
      return [e[0], e[1], e[2], e[3]];
    }
  }, {
    key: "pointToArray",
    value: function pointToArray(e) {
      return [e.x, e.y, e.z, e.m];
    }
  }, {
    key: "vectorToPoint",
    value: function vectorToPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new T();
      return t.x = e[0], t.y = e[1], t.z = e[2], t.m = e[3], t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "arrayToPoint",
    value: function arrayToPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new T();
      return t.x = e[0], t.y = e[1], t.z = e[2], t.m = e[3], t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "vectorToDehydratedPoint",
    value: function vectorToDehydratedPoint(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        x: void 0,
        y: void 0,
        z: void 0,
        m: void 0,
        hasZ: void 0,
        hasM: void 0,
        spatialReference: void 0,
        type: "point"
      };
      return t.x = e[0], t.y = e[1], t.z = e[2], t.m = e[3], t.hasZ = !0, t.hasM = !0, t.spatialReference = this.spatialReference, t;
    }
  }, {
    key: "lerp",
    value: function lerp(e, t, r, a) {
      return v(a, e, t, r);
    }
  }, {
    key: "addDelta",
    value: function addDelta(e, t, r, a) {
      e[0] += t, e[1] += r, e[2] += a;
    }
  }, {
    key: "distance",
    value: function distance(e, t) {
      return o(e, t);
    }
  }, {
    key: "getZ",
    value: function getZ(e) {
      return e[2];
    }
  }, {
    key: "hasZ",
    value: function hasZ() {
      return !0;
    }
  }, {
    key: "getM",
    value: function getM(e) {
      return e[3];
    }
  }, {
    key: "hasM",
    value: function hasM() {
      return !0;
    }
  }, {
    key: "clone",
    value: function clone(e) {
      return this.tag(f(e));
    }
  }, {
    key: "copy",
    value: function copy(e, t) {
      return y(t, e);
    }
  }, {
    key: "fromXYZ",
    value: function fromXYZ(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return this.tag(d(e[0], e[1], e.length > 2 ? e[2] : t, r));
    }
  }, {
    key: "toXYZ",
    value: function toXYZ(e) {
      return c(e[0], e[1], e[2]);
    }
  }, {
    key: "tag",
    value: function tag(e) {
      return e;
    }
  }]);

  return R;
}();

function x(e, t, r) {
  return e && t ? new R(r) : t ? new g(1, r) : e ? new g(0, r) : new m(r);
}

export { m as CoordinateHelper2D, g as CoordinateHelper3D, R as CoordinateHelper4D, x as createCoordinateHelper };